import { configs } from '$configs';
import { SORT, COLORS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { defaultDataSource, defaultStyles, TableModel } from '$gbusiness/models/table';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Button } from '@mui/material';
import { deriveRawToStoreLevel } from '$fbusiness/models/storeLevel';

export const STORE_LEVEL_TABLE_CONFIG: TableModel = {
  dataSource: {
    ...defaultDataSource,
    endpoint: configs.api.storeLevel,
    method: 'GET',
    deriveToModel: deriveRawToStoreLevel,
    defaultSortKey: 'createdAt',
    defaultSortOrder: SORT.DSC,
    shouldVirtualize: false,
    pageSize: 20,
  },
  styles: {
    ...defaultStyles,
    color: COLORS.LIGHT,
    fontSize: '1em',
    minWidth: 300,
    maxWidth: 800,
    cellPadding: ` 8px 4px`,
    isStripped: true,
    responsive: true,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

export const STORE_LEVEL_TABLE = (): Array<CellModel> => [
  {
    label: 'SCREEN.STORE_LEVELS.COLS.NAME',
    value: 'name',
    alwaysShow: true,
    sortable: SORT.ASC,
    width: 250,
  },
  {
    label: 'SCREEN.STORE_LEVELS.COLS.LEVEL',
    value: 'level',
    sortable: SORT.ASC,
    width: 150,
  },
  {
    label: 'SCREEN.STORE_LEVELS.COLS.RATE',
    value: 'discountRate',
    sortable: SORT.ASC,
    width: 150,
  },
  {
    label: 'SCREEN.STORE_LEVELS.COLS.FLAT',
    value: 'discountFlat',
    sortable: SORT.ASC,
    width: 150,
  },
  {
    label: '',
    value: '',
    className: 'action',
    align: 'center',
    component: (row, actions) => {
      return (
        <Button
          className="left"
          color="secondary"
          fullWidth
          onClick={(e) => actions.handlePopoverOpen(e, row)}>
          <MoreHorizIcon />
        </Button>
      );
    },
    width: 100,
  },
];
